module.exports = "/_next/static/images/e6370908240c75d153670ea26ec71514-multiproduct-xs.jpg.webp";